<template>
  <div id="J_ushk" class="ushk ushk-calendar">
    <div class="ushk-container">
      <div class="ushk-box">
        <ushk-header></ushk-header>
        <div class="ushk-page">
          <div class="ushk-wrap ushk-wrap-main">
            <home></home>
          </div>
        </div>
      </div>
      <ushk-footer></ushk-footer>
    </div>
  </div>
</template>
<style type="text/css" lang="scss">
  @import './style/index.scss';
</style>
<script>
  import Home from './pages/home'
  export default {
    name: 'appStatic',
    computed: {

    },
    components: {
      Home
    },
    created () {

    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?f2093734